import React from 'react';
import { connect } from 'react-redux';
import { Input, Button, CheckboxTable, Select, PaperClip } from 'components';
import { FormalityService, StorageService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { ViewIcon, PaperclipIcon } from 'assets/icons';

interface Props {
  onClose?: any;
  item?: any;
  user?: any;
}

interface State {
  loadingFile: boolean;
  loadingFileResponse: boolean;
}

class ModalView extends React.Component<Props, State> {
  state: State = {
    loadingFile: false,
    loadingFileResponse: false,
  };

  openFile = async (key: string, field: 'loadingFile' | 'loadingFileResponse') => {
    this.setState({ [field]: true } as any);
    const opened = await StorageService.openFile(key);
    if (!opened) Globals.showError('No se pudo obtener el archivo');
    this.setState({ [field]: false } as any);
  };

  render() {
    const { item } = this.props;
    const { loadingFile, loadingFileResponse } = this.state;

    return (
      <div id='modal-view-revision'>
        {item != null && (
          <div className='container-modal'>
            <p className='number'>
              {item.number} / {moment(item.created_at).format('DD-MM-YYYY')}
            </p>
            <p className='subtitle'>Cliente</p>
            <p>{item.user?.full_name}</p>
            <p>{item.user?.full_document}</p>
            <p className='subtitle'>Enviado por el cliente</p>
            <p>{moment(item.created_at).format('DD-MM-YYYY')}</p>
            {item.file != null &&
              (this.props.user?.level_id === Constants.LEVELS.MODERATOR ? (
                <button
                  type='button'
                  className='container-file'
                  disabled={loadingFile}
                  onClick={() => this.openFile(item.file, 'loadingFile')}
                >
                  <div className='container-clip'>
                    <img src={PaperclipIcon} className='clip' />
                  </div>
                  <p>Archivo</p>
                  {loadingFile ? (
                    <span className='doc-loader' />
                  ) : (
                    <img src={ViewIcon} className='view' />
                  )}
                </button>
              ) : (
                <div className='container-file' style={{ cursor: 'default' }}>
                  <div className='container-clip'>
                    <img src={PaperclipIcon} className='clip' />
                  </div>
                  <p>Archivo</p>
                </div>
              ))}
            <hr />
            {item.lawyer != null && (
              <>
                <p className='subtitle'>Abogado</p>
                <p>{item.lawyer?.full_name}</p>
                <p>{item.lawyer?.lawyer_document}</p>
              </>
            )}
            {item.file_response != null && (
              <>
                <p className='subtitle'>Enviado por el abogado</p>
                <p>{moment(item.response_date).format('DD-MM-YYYY')}</p>
                {this.props.user?.level_id === Constants.LEVELS.MODERATOR ? (
                  <button
                    type='button'
                    className='container-file'
                    disabled={loadingFileResponse}
                    onClick={() => this.openFile(item.file_response, 'loadingFileResponse')}
                  >
                    <div className='container-clip'>
                      <img src={PaperclipIcon} className='clip' />
                    </div>
                    <p>Archivo</p>
                    {loadingFileResponse ? (
                      <span className='doc-loader' />
                    ) : (
                      <img src={ViewIcon} className='view' />
                    )}
                  </button>
                ) : (
                  <div className='container-file' style={{ cursor: 'default' }}>
                    <div className='container-clip'>
                      <img src={PaperclipIcon} className='clip' />
                    </div>
                    <p>Archivo</p>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(ModalView);
